import type { RatingTrend } from '../common/scorecardInsights';

type RatingTrendIndicatorProps = {
  trend: RatingTrend;
};

function TrendIcon({ direction }: { direction: RatingTrend['direction'] }) {
  const path =
    direction === 'up'
      ? 'M3 13 13 3M8 3h5v5'
      : direction === 'down'
        ? 'm3 3 10 10M13 8v5H8'
        : 'M2 8h12M10 4l4 4-4 4';

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      className="h-5 w-5 shrink-0"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={path} />
    </svg>
  );
}

export function RatingTrendIndicator({ trend }: RatingTrendIndicatorProps) {
  return (
    <div
      aria-label={trend.label}
      role="img"
      className="mt-2 flex items-center justify-center gap-1.5 text-sm font-semibold"
    >
      <TrendIcon direction={trend.direction} />
      <span>{trend.direction === 'flat' ? 'Flat' : 'Trending'}</span>
    </div>
  );
}
